import { useState } from 'react';
import { postMAKAB020 } from '../../../../services/Api';
const PopupPAIAF030 = ({ closePopup, dataPopup, activeTabIndex, refreshData }) => {
    const [mailData, setMailData] = useState({
        title: '',
        content: '',
    });

    const [sendMail, setSendMail] = useState(false);
    const handleChange = (e) => {
        setMailData({
            ...mailData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = () => {
        if (sendMail) {
            if (mailData.title.trim() === '' || mailData.content.trim() === '') {
                window.alert('모든 정보를 입력해 주세요.');
                return;
            }
            const payload = {
                toMemberId:
                    dataPopup.type === 'SND'
                        ? dataPopup?.toMemberID
                        : dataPopup.type === 'REV'
                        ? dataPopup?.fromMemberID
                        : '',
                readed: 'N',
                title: mailData.title,
                contents: mailData.content,
                tblName: 'propose',
                revDel: 'N',
                sendDel: 'N',
            };

            postMAKAB020(payload)
                .then(() => {
                    window.alert('쪽지가 성공적으로 전송되었습니다.');
                    if (refreshData) refreshData();
                    closePopup();
                })
                .catch((error) => {
                    window.alert('쪽지 전송에 실패하였습니다.');
                    console.log(error);
                });
        } else {
            setSendMail(true);
        }
    };

    return (
        <div className={`sendPop active`} id="sendPop">
            <div className="sendPop__container" style={{ padding: '25px', maxWidth: '550px' }}>
                <button id="sendPopClose" type="button" className="sendPop__close" onClick={closePopup} />
                <h2 className="sendPop__tit" style={{ display: 'flex', gap: '10px', color: '#0055cc' }}>
                    <div className="outer-circle blue"></div> My 쪽지
                </h2>
                <p className="sendPop__desc">덴탈잡은 항상 더 좋은 서비스를 제공하기 위해서 최선을 다하겠습니다.</p>
                {sendMail ? (
                    <table className="sendPop__table">
                        <tbody>
                            <tr>
                                <th>보내는 사람</th>
                                <td>
                                    <input
                                        type="text"
                                        className="sendPop__input"
                                        name="sender"
                                        value={
                                            dataPopup.type === 'SND'
                                                ? dataPopup?.fromNameKor
                                                : dataPopup.type === 'REV'
                                                ? dataPopup?.toBizCompany
                                                : ''
                                        }
                                        readOnly
                                        style={{ backgroundColor: '#eee' }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>받는 사람</th>
                                <td>
                                    <input
                                        type="text"
                                        className="sendPop__input"
                                        name="receiver"
                                        value={
                                            dataPopup.type === 'SND'
                                                ? dataPopup?.toBizCompany
                                                : dataPopup.type === 'REV'
                                                ? dataPopup?.fromNameKor
                                                : ''
                                        }
                                        readOnly
                                        style={{ backgroundColor: '#eee' }}
                                    />
                                </td>
                            </tr>
                            {/* <tr>
                                <th>
                                    제목<span style={{ marginLeft: '5px', color: '#0055cc' }}>*</span>
                                </th>
                                <td>
                                    <input
                                        type="text"
                                        className="sendPop__input"
                                        name="title"
                                        value={mailData.title}
                                        onChange={handleChange}
                                        required
                                    />
                                </td>
                            </tr> */}
                            <tr>
                                <th>
                                    내용<span style={{ marginLeft: '5px', color: '#0055cc' }}>*</span>
                                </th>
                                <td>
                                    <textarea
                                        name="content"
                                        className="sendPop__textarea"
                                        value={mailData.content}
                                        onChange={handleChange}
                                        required
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                ) : (
                    <table className="rsm-dtl__table rsm-dtl__table--ver2 wd170">
                        <tbody>
                            <tr>
                                <th>보내는 사람</th>
                                <td>
                                    {dataPopup.type === 'SND'
                                        ? dataPopup?.fromNameKor
                                        : dataPopup.type === 'REV'
                                        ? dataPopup?.toBizCompany
                                        : ''}
                                </td>
                            </tr>
                            <tr>
                                <th>받는 사람</th>
                                <td>
                                    {dataPopup.type === 'SND'
                                        ? dataPopup?.toBizCompany
                                        : dataPopup.type === 'REV'
                                        ? dataPopup?.fromNameKor
                                        : ''}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    제목<span style={{ marginLeft: '5px', color: '#0055cc' }}>*</span>
                                </th>
                                <td>{dataPopup?.title}</td>
                            </tr>
                            <tr>
                                <th>
                                    내용<span style={{ marginLeft: '5px', color: '#0055cc' }}>*</span>
                                </th>
                                <td>{dataPopup?.contents}</td>
                            </tr>
                        </tbody>
                    </table>
                )}
                <div className="sendPop__btbx">
                    <button type="button" className="sendPop__btn" onClick={handleSubmit}>
                        쪽지 보내기
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PopupPAIAF030;
